import { render, staticRenderFns } from "./ztSizeProvider.vue?vue&type=template&id=4a6a2fb2"
import script from "./ztSizeProvider.vue?vue&type=script&lang=js"
export * from "./ztSizeProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../web-empleado/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports